var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2027_20070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.7488 10.2513C53.1381 3.64068 44.3488 0 35 0C25.6512 0 16.8619 3.64068 10.2512 10.2513C3.64068 16.8619 0 25.6512 0 35C0 44.3488 3.64068 53.1381 10.2512 59.7487C16.8619 66.3593 25.6512 70 35 70C44.3488 70 53.1381 66.3593 59.7488 59.7487C66.3593 53.1381 70 44.3488 70 35C70 25.6512 66.3593 16.8619 59.7488 10.2513ZM35 65.8984C25.8578 65.8984 17.6317 61.906 11.9695 55.5747C15.4797 46.2686 24.4655 39.6484 35 39.6484C28.2043 39.6484 22.6953 34.1395 22.6953 27.3438C22.6953 20.548 28.2043 15.0391 35 15.0391C41.7957 15.0391 47.3047 20.548 47.3047 27.3438C47.3047 34.1395 41.7957 39.6484 35 39.6484C45.5345 39.6484 54.5203 46.2686 58.0305 55.5747C52.3683 61.906 44.1422 65.8984 35 65.8984Z",
    fill: "#898989"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2027_20070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.15b435c95c60d5d258dc0a7b12731712.svg";
export { ForwardRef as ReactComponent };